import { Col, Nav, Row, Tab } from "react-bootstrap";
import 'react-quill/dist/quill.snow.css';
import "../../../assets/css/createevent/CreateEvent.css"

import BasicInformation from "../../components/CreateEvent/BasicInformation";
import PackageDetails from "../../components/CreateEvent/PackageDetails";
import Pitch from "../../components/CreateEvent/Pitch";
import MediaHub from "../../components/CreateEvent/MediaHub";
import SocialMedia from "../../components/CreateEvent/SocialMedia";
import { useEffect, useState } from "react";
import SpeakerList from "../../components/CreateEvent/SpeakerList";
import DomainInfo from "../../components/CreateEvent/DomainInfo";
import TermsAndCompliance from "../../components/CreateEvent/Terms_Compliace";

const CreateMyEvent = () => {
    const [tabValue, setTabValue] = useState("Basic-Information");
    // const [eventId, setEventId] = useState('')
    const [eventId, setEventId] = useState('678e203e67d422d384b2990e');



    useEffect(() => {

    }, [])


    return (
        <>

            <Row>
                <Col lg={12}>
                    <div className="card">
                        <div className="card-header">
                            <h4 className="card-title">Create Event</h4>

                            <button className="btn" style={{ padding: "8px", border: "1px solid #6a73fa", color: "#6a73fa" }} onClick={() => window.history.back()}>Back</button>
                        </div>
                        <div className="card-body">


                            <div className="row mb-5 mt-2">
                                <div className="tab-container">
                                    <button
                                        className={`${tabValue === "Basic-Information" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Basic-Information")}
                                    >
                                        Event Basic
                                    </button>
                                    <button
                                        className={`${tabValue === "Packages" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Packages")}
                                    >
                                        Ticketing Information
                                    </button>
                                    {/* <button
                                        className={`${tabValue === "Pitch" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Pitch")}
                                    >
                                        Pitch
                                    </button> */}
                                    <button
                                        className={`${tabValue === "Media-Hub" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Media-Hub")}
                                    >
                                        Event Media Hub
                                    </button>
                                    <button
                                        className={`${tabValue === "Speaker-List" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Speaker-List")}
                                    >
                                        Speaker List
                                    </button>
                                    <button
                                        className={`${tabValue === "Domain-Info" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Domain-Info")}
                                    >
                                        Domain Info
                                    </button>
                                    <button
                                        className={`${tabValue === "Social-Media" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Social-Media")}
                                    >
                                        Social Media
                                    </button>
                                    <button
                                        className={`${tabValue === "Terms-Compliance" ? "create-event-active-tab" : "create-event-tab"}`}
                                        onClick={() => setTabValue("Terms-Compliance")}
                                    >
                                        Terms & Compliance
                                    </button>
                                </div>


                                <div className="row mt-5">

                                    {tabValue == "Basic-Information" ? (
                                        <div className="">
                                            <BasicInformation setEventId={setEventId} setTabValue={setTabValue} />
                                        </div>
                                    ) : tabValue == "Packages" ? (
                                        <div className="">
                                            <PackageDetails eventId={eventId} setTabValue={setTabValue} />
                                        </div>
                                    ) : tabValue == "Pitch" ? (
                                        <div className="">
                                            <Pitch eventId={eventId} setTabValue={setTabValue} />
                                        </div>
                                    ) : tabValue == "Media-Hub" ? (
                                        <div className="">
                                            <MediaHub eventId={eventId} setTabValue={setTabValue} />
                                        </div>
                                    ) : tabValue == "Speaker-List" ? (
                                        <div className="">
                                            <SpeakerList eventId={eventId} setTabValue={setTabValue} />
                                        </div>
                                    ) : tabValue == "Domain-Info" ? (
                                        <div className="">
                                            <DomainInfo eventId={eventId} setTabValue={setTabValue} />
                                        </div>
                                    ) : tabValue == "Social-Media" ? (
                                        <div className="">
                                            <SocialMedia eventId={eventId} setTabValue={setTabValue}/>
                                        </div>
                                    ) : tabValue == "Terms-Compliance" ? (
                                        <div className="">
                                            <TermsAndCompliance eventId={eventId} setTabValue={setTabValue} />
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>

        </>
    )
}

export default CreateMyEvent;

